import { combineReducers } from "redux";
import Candidate from "./candidateReducer";
import Position from "./positionReducer";
import Question from "./questionReducer";
import Dashboard from "./dashboardReducer";
import Profile from "./profileReducer";
import Survey from "./surveyReducer";
import Csat from "./csatReducer";
const appReducer = combineReducers({
  Candidate,
  Position,
  Question,
  Dashboard,
  Profile,
  Survey,
  Csat,
});

const reducers = (state, action) => {
  return appReducer(state, action);
};

export default reducers;
